import { apiRequest } from '@/shared/api/http'
import type {
  ChangePasswordRequest,
  LoginRequest,
  MeResponse,
  TokenPairResponse,
} from '@/features/auth/domain/auth.types'

const AUTH_ENDPOINT = '/v1/auth'

// `refresh` is intentionally NOT here — it lives in shared/api/auth-tokens.ts on a bare,
// interceptor-free client so a refresh 401 can never re-enter the refresh path.
export const authApi = {
  login: (body: LoginRequest) =>
    apiRequest<TokenPairResponse>(`${AUTH_ENDPOINT}/login`, {
      method: 'POST',
      body,
    }),

  logout: () =>
    apiRequest<null>(`${AUTH_ENDPOINT}/logout`, {
      method: 'POST',
    }),

  me: (signal?: AbortSignal) =>
    apiRequest<MeResponse>(`${AUTH_ENDPOINT}/me`, {
      method: 'GET',
      signal,
    }),

  changePassword: (body: ChangePasswordRequest) =>
    apiRequest<TokenPairResponse>(`${AUTH_ENDPOINT}/me/password`, {
      method: 'PUT',
      body,
    }),
}
